import { createActionConst } from '../../../utils/action.utils';

const ANSWER_NAMESPACE = 'ANSWER';

export const STORE_ANSWER = createActionConst(ANSWER_NAMESPACE, 'STORE_ANSWER');
export const CLEAR_ANSWER = createActionConst(ANSWER_NAMESPACE, 'CLEAR_ANSWER');
